"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.typeThumbnails = exports.globalFilters = exports.TRASH_FOLDER_NAME = void 0;
/* eslint-disable global-require */

var TRASH_FOLDER_NAME = exports.TRASH_FOLDER_NAME = '_trash';
var typeThumbnails = exports.typeThumbnails = {
  mp3: require('./images/mp3.svg')
};
var globalFilters = exports.globalFilters = {
  audio: {
    regex: /\.mp3$/,
    accept: '.mp3'
  },
  image: {
    regex: /\.(jpg|jpeg|png|svg)$/,
    accept: '.jpg,.jpeg,.png,.svg'
  },
  pdf: {
    regex: /\.pdf$/,
    accept: '.pdf'
  },
  video: {
    regex: /\.mp4$/,
    accept: '.mp4'
  }
};